module.exports = __webpack_public_path__ + "static/img/ai_floating.8c6098d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/ai_floating.png
// module id = 51vf
// module chunks = 1